(
    function (skyward, $, undefined)
    {
        "use strict";

        skyward.childrecordquickentry = skyward.childrecordquickentry || {};
        var processedIds = [];

        var init = function (selector)
        {
            var element = $(selector);

            if (element.is(".childrecordquickentryrow"))
            {
                initCRQE(element);
            }
            else
            {
                element.find(".childrecordquickentry").each(function ()
                {
                    var crqe = $(this);

                    // don't initialize nested CRQEs, they are already initialized by their parent
                    if (crqe.parents(".childrecordquickentry").length === 0)
                    {
                        initCRQE(crqe);
                    }
                });
            }
        };

        var initCRQE = function (container)
        {
            processedIds = [];

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters = function (container)
            {
                var recursiveGetStringFromInt = function (count)
                {
                    if (count < 26)
                    {
                        return String.fromCharCode(65 + count);
                    }
                    else
                    {
                        return recursiveGetStringFromInt(Math.floor(count / 26) - 1) + recursiveGetStringFromInt(count % 26);
                    }
                };

                /**
                 * Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 * @param {Number} count 1-based index
                 * @returns {string} Returns an Excel styled index (1>A, 2>B, ..., 25>Y, 26>Z, 27>AA, 28>AB)
                 */
                var getStringFromInt = function (count)
                {
                    return recursiveGetStringFromInt(count - 1);
                };

                container.find('.getChildRecordQuickEntryNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    numberElement.html(myRow);
                });

                container.find('.getChildRecordQuickEntryTextAndNumber').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr');
                    var myRow = tr.index();
                    var header = numberElement.find('.sectionHeader__text, .legendHeader');
                    var valueToSet = header.length > 0 ? header : numberElement;
                    valueToSet.text(valueToSet.text().split(' ')[0] + ' ' + myRow);
                });

                container.find('tr:not(.js_hideEmptyRowWithAddButton) .getChildRecordQuickEntryLetter').each(function ()
                {
                    var numberElement = $(this);
                    var tr = numberElement.closest('tr:not(.js_hideEmptyRowWithAddButton)');
                    var myRow = tr.index('#' + container.attr("id") + ' tr:not(.js_hideEmptyRowWithAddButton)');
                    numberElement.html(getStringFromInt(parseInt(myRow)));
                });
            };

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];

            // Update nested repeaters that start on the page
            container.find(' tr.childrecordquickentryrow tr.childrecordquickentryrow').each(function ()
            {
                var myElement = $(this);
                var isProcessed = processedIds.includes(myElement.attr('id'));
                var contentDiv = myElement.parents('.childrecordquickentry').eq(0).not(".disablenestedrepeaterrename");

                if (!isProcessed && contentDiv.length > 0)
                {
                    var counter = getUniqueRowID(container);

                    initializeChildRecordIDs(myElement, counter);
                    initializeElementsAndData(myElement, counter, container, null /*row*/, contentDiv.hasClass('preserveprefilledvalues'));
                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    skyward.window.notifyDOMLoad("#" + contentDiv.attr('id'));
                }
            });

            // template creation
            container.find('.usequickentrytemplate').not('.doNotPost').each(function ()
            {
                var initialRow = $(this);
                initialRow.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it
                var tempObject = initialRow.clone(true, true);

                if (tempObject.length)
                {
                    var codeEELsToClear = [];

                    // pop the counter off of the template
                    var tempObjectIdParts = tempObject.attr('id').split('-');
                    if (skyward.extensions.isNumeric(tempObjectIdParts[tempObjectIdParts.length - 1]))
                    {
                        tempObjectIdParts.pop();
                    }

                    tempObject.attr('id', tempObjectIdParts.join('-') + '-Template');
                    tempObject.addClass('doNotPost');

                    // append "-Template" onto child elements' ids and names
                    tempObject.find("[id],[name]").each(function ()
                    {
                        var element = $(this);
                        var elementId;
                        var elementName;

                        if (!element.is(elementTypesToInitialize.join(',')))
                        {
                            return;
                        }

                        // pop the counter off of the element id/name
                        if (element.attr('id'))
                        {
                            var elementIdParts = element.attr('id').split('-');
                            var idCounterWithPostFix = elementIdParts[elementIdParts.length - 1];

                            var idCounter = idCounterWithPostFix;
                            var idPostFix = '';

                            if (idCounterWithPostFix.indexOf('_') > -1)
                            {
                                idCounter = idCounterWithPostFix.substring(0, idCounterWithPostFix.indexOf('_'));
                                idPostFix = idCounterWithPostFix.substring(idCounterWithPostFix.indexOf('_'));
                            }

                            if (skyward.extensions.isNumeric(idCounter))
                            {
                                elementIdParts.pop();
                                elementId = elementIdParts.join('-') + '-Template';

                                if (idPostFix)
                                {
                                    elementId += idPostFix;
                                }

                                // Update labels pointing at this control
                                const currentId = element.attr('id');

                                tempObject.find(`[for='${currentId}']`).attr('for', elementId);
                                tempObject.find(`[aria-labelledby='${currentId}']`).attr('aria-labelledby', elementId);
                                tempObject.find(`[aria-describedby='${currentId}']`).attr('aria-describedby', elementId);

                                const elementRequestDataHashSrc = element.data().requestDataHashSrc;
                                // Elements that should be ignored when initializing request data hashes
                                const isIgnoredElement = element.is(".tileViewEEL_search");
                                if (elementRequestDataHashSrc && !isIgnoredElement)
                                {
                                    const prefix = initialRow.getPrefix();
                                    const hashKey = element.data().requestDataHashKey ?? element.getIdAndPrefix(prefix).id;
                                    const requestDataHashes = skyward.requestDataHash.getRequestDataHashes(elementRequestDataHashSrc);
                                    const requestDataHash = skyward.requestDataHash.getRequestDataHash(elementRequestDataHashSrc, hashKey);
                                    if (requestDataHash)
                                    {
                                        const newTrueId = elementId.replace(prefix, '');
                                        requestDataHashes[newTrueId] = $.extend(true, {}, requestDataHash);
                                    }
                                }

                                element.attr('id', elementId);
                            }
                        }

                        if (element.attr('name'))
                        {
                            var elementNameParts = element.attr('name').split('-');

                            var nameCounterWithPostFix = elementNameParts[elementNameParts.length - 1];

                            // radio button names will have 'child' appended to the counter with no '_' separator
                            var counterPostFix = element.is(':radio') ? 'child' : '_';

                            var nameCounter = nameCounterWithPostFix;
                            var namePostFix = '';

                            if (nameCounterWithPostFix.indexOf(counterPostFix) > -1)
                            {
                                nameCounter = nameCounterWithPostFix.substring(0, nameCounterWithPostFix.indexOf(counterPostFix));
                                namePostFix = nameCounterWithPostFix.substring(nameCounterWithPostFix.indexOf(counterPostFix));
                            }

                            if (skyward.extensions.isNumeric(nameCounter))
                            {
                                elementNameParts.pop();
                                elementName = elementNameParts.join('-') + '-Template';

                                if (namePostFix)
                                {
                                    elementName += namePostFix;
                                }

                                element.data("original-name", element.data("original-name") ?? elementName);
                                element.attr('name', elementName);
                            }
                        }

                        var clonevalue = getDataClonevalue(element);
                        var takeDefaultValue = getDataTakeDefaultValue(element);

                        element.addClass('doNotPost');

                        if (elementId || elementName)
                        {
                            // CodeEELs are cleared seperately
                            if (element.is('.codeEELCode,.codeEELDescription,.codeEELValue,.tileViewEEL_search,.tileViewEEL_value') && element.parent().length)
                            {
                                codeEELsToClear.push(element.parent());
                            }
                            // Clear any prefilled value for the template
                            else if (!element.is('label') && takeDefaultValue != true)
                            {
                                let valueToSet;
                                if (element.is(".datePicker,sky-datepicker"))
                                {
                                    const datePicker = element.closest("sky-datepicker");
                                    valueToSet = clonevalue ? datePicker.data('original-value') : null
                                    datePicker.val(valueToSet);
                                }
                                else
                                {
                                    valueToSet = clonevalue ? element.data('original-value') : null
                                    skyward.controls.setValue(element, valueToSet, true);
                                }
                            }
                        }
                    });

                    $(codeEELsToClear).each(function ()
                    {
                        skyward.codeeel.clear($(this), false);
                    });

                    // We want load-actions to only apply on copies of the template
                    // not the template itself.
                    skyward.events.removeLoadActionClass(tempObject);

                    tempObject.css("display", "none");

                    // See if there's already a copy of the template in the container and replace it with the new one if so
                    var existingTemplate = container.find("#" + tempObject.attr("id"));
                    if (existingTemplate.length > 0)
                    {
                        existingTemplate.replaceWith(tempObject);
                    }
                    else
                    {
                        tempObject.appendTo(container);
                    }
                }
            });

            container.find('td.childrecordquickentryclearbuttoncell').each(function ()
            {
                var clearButton = $(this);

                var clearRowFields = function (preserveParent, parent)
                {
                    var childInputElements = parent.find(':input, textarea, select, textarea, select, .file').filter(':visible');
                    var inputElements = $.makeArray(childInputElements);

                    // clear EEL elements hidden values
                    parent.find('[data-action="codeEEL"], [data-action="tileViewEEL"]').each(function ()
                    {
                        var element = $(this);
                        skyward.controls.setValue(element, '');

                        // Trigger any attached onchange event
                        element.change();
                    });

                    //clear distinctMultiSelectEEL elements
                    parent.find('.distinctMultiSelectEEL').each(function ()
                    {
                        var element = $(this);
                        skyward.distinctMultiSelectEEL.values.clear(element);
                        skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(element);
                    });

                    // list to store 'dirty' input fields
                    var dirtyList = [];

                    // find the controls that have triggered a 'dirty' condition.
                    if (inputElements.length > 0)
                    {
                        for (var child in inputElements)
                        {
                            var input = inputElements[child];
                            var test = input.getAttribute('data-dirty');

                            if (test != null && test)
                            {
                                dirtyList.push(input);
                            }

                            var jQueryInput = $(input);
                            if (jQueryInput.hasClass('file'))
                            {
                                var deleteButton = jQueryInput.find('a[id*="Delete"]');
                                if (deleteButton && deleteButton != null)
                                {
                                    deleteButton.trigger('click');
                                }
                            }
                        }
                    }

                    // selected dirty inputs
                    var selectedDirtyList = [];

                    // 'select' the inputs
                    for (var inputs in dirtyList)
                    {
                        var inputsToAdd = $(dirtyList[inputs]);
                        selectedDirtyList.push(inputsToAdd);
                    }

                    // clear the fields
                    if (preserveParent)
                    {
                        parent.find(':input:not([type=radio], [type=checkbox]), textarea, select').filter(':visible').each(function ()
                        {
                            const element = $(this);
                            if (element.is("select"))
                            {
                                // Set it to the default selected field, or 0 if there is no default
                                var defaultSelectedIndex = 0;
                                Array.from(this.options).forEach((option) => {
                                    if (option.defaultSelected === true)
                                    {
                                        defaultSelectedIndex = option.index;
                                    }
                                })
                                skyward.controls.setValue(element, this.options[defaultSelectedIndex].value);
                            }
                            else
                            {
                                skyward.controls.setValue(element, null);
                            }
                        });
                    }

                    parent.find('input:checked').filter(':visible').each(function ()
                    {
                        var inputCheckbox = $(this);
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (!inputCheckbox[0].defaultChecked)
                            {
                                skyward.controls.setValue(inputCheckbox, false, true);
                                radioButtonGroup.find('input').not(':checked').each(function ()
                                {
                                    if (this.defaultChecked)
                                    {
                                        var uncheckedRadioButton = $(this);
                                        skyward.radioButtonGroup.setValue(uncheckedRadioButton, uncheckedRadioButton.val());
                                    }
                                });
                            }
                        }
                        else
                        {
                            skyward.controls.setValue(inputCheckbox, false, true);
                        }

                        if (inputCheckbox.hasClass('AddressFlag'))
                        {
                            skyward.childrecordquickentry.addressFlagCheck(inputCheckbox, true);
                        }
                    });

                    // remove the found items from the dirty list in changetracking.js
                    if (selectedDirtyList.length > 0)
                    {
                        skyward.changeTracking.removeFromDirtyList(selectedDirtyList);
                    }

                    //trigger changetracking dirty condition from an existing field
                    var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                    var inputToTrigger = dataObjectViewer.find(':input, textarea').eq(0);
                    inputToTrigger.change();
                };

                var clearRow = function ()
                {
                    var button = $(this);
                    var parent = button.parent('tr.childrecordquickentryrow');
                    if (parent.next().is(".childRecordTemplateRow"))
                    {
                        parent = parent.add(parent.next());
                    }
                    var parentSplit = parent.attr('id').split('-');
                    var isRowBeingRemoved = parentSplit[parentSplit.length - 1] !== '1';
                    if (!isRowBeingRemoved || parent.parents('.childrecordquickentrytable').first().find('.newchildrecordquickentryrow-1').first().attr('id') == parent.attr('id'))
                    {
                        clearRowFields.call(button, true, parent);
                        isRowBeingRemoved = false;
                    }
                    else //clear and remove table row
                    {
                        parent.fadeOut(500, 'linear', function ()
                        {
                            parent.css('display', 'none');
                            clearRowFields.call(button, false, parent);

                            var siblingRow = parent.prev('tr');
                            if (!siblingRow.length)
                            {
                                siblingRow = parent.next('tr');
                            }

                            // Necessary for row removal event listeners
                            const elementBeingRemoved = parent.find('.js-childrecordquickentryremove');
                            skyward.controls.setValue(elementBeingRemoved, "true");
                            button.trigger('childrecordquickentry-row-removed', [parent]);

                            parent.remove();
                            maxNumberAdded(siblingRow);
                            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(siblingRow.closest(".childrecordquickentry"));
                        });
                    }
                    button.trigger('childrecordquickentry-row-cleared', [parent, isRowBeingRemoved]);
                };
                clearButton.off("click").on('click', clearRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(clearButton);
                }
            });

            container.find(' .js-childRecordQuickEntryClearRow').each(function ()
            {
                var removeButton = $(this);

                var removeRow = function ()
                {
                    var row = removeButton.closest('tr');
                    row.addClass("removedElement");

                    row.fadeOut(500, 'linear', function ()
                    {
                        row.css('display', 'none');
                    });

                    var elementBeingRemoved = row.find('.js-childRecordQuickEntryRowValues');
                    skyward.controls.setValue(elementBeingRemoved, "true");
                    removeButton.trigger('childrecordquickentry-row-removed', [row]);
                    maxNumberAdded(row);
                    var triggerEvent = 'childrecordquickentryremoverowajaxevent-' + elementBeingRemoved.attr('id');
                    removeButton.trigger(triggerEvent);
                };

                removeButton.off("click").on('click', removeRow);

                if (skyward.global.mobileAccess)
                {
                    setupButtonToBeResponsiveOnMobile(removeButton.closest(".childrecordquickentryremovebuttoncell"));
                }
            });

            container.find('input.AddressFlag').each(function ()
            {
                var element = $(this);
                var value = skyward.controls.getValue(element);
                if (value)
                {
                    skyward.controls.disable(element);
                }
                skyward.childrecordquickentry.addressFlagCheck(element, false);
            });

            container.find('input.AddressExistingRecordsNotReadOnly').each(function ()
            {
                skyward.controls.enable(this);
            });

            container.find('div.childrecordquickentryadddiv a').each(function ()
            {
                var addButton = $(this);

                if (addButton.length === 0)
                {
                    return;
                }

                var generateNewRow = function (button, prefixOverride = null)
                {
                    var { id: buttonId, prefix: dovPrefix } = button.getIdAndPrefix(prefixOverride);
                    var allButtonIdParts = buttonId.split('-');
                    var buttonIdParts = allButtonIdParts.slice(-4); //we never use the first id part so get rid of it
                    var addButtonIndex = buttonIdParts.indexOf("childrecordquickentryaddbutton");
                    var nestedRepeater = button.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
                    var prefixedRowId = `${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[addButtonIndex + 1]}-${buttonIdParts[addButtonIndex + 2]}-`;
                    // First childrecordquickentry ancestor - never grandparent
                    var mainDiv = button.parents('.childrecordquickentry').eq(0);

                    // find the highest row count
                    var legendContentDiv = button.parent('div').parent('div');
                    var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

                    var row;
                    if (nestedRepeater.length)
                    {
                        row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
                    }
                    else
                    {
                        row = mainDiv.find('#' + prefixedRowId + previousRowID);
                    }

                    row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

                    // Clone the row including all data and bound events. This will also carry over any structure such as the number of nested CRQE rows.
                    var newRow = row.clone(true, true);
                    var container = getTopCRQEContainerFromElement(addButton);
                    var newRowID = getUniqueRowID(container);
                    newRow.attr('id', prefixedRowId + newRowID);
                    if (newRow.hasClass("js_hideEmptyRowWithAddButton"))
                    {
                        newRow.removeClass("js_hideEmptyRowWithAddButton");
                    }

                    var newTemplateRow = null;
                    if (row.next().is(".childRecordTemplateRow"))
                    {
                        newTemplateRow = row.next().clone(true, true);
                    }

                    var rowParentRows = row.parents('tr.childrecordquickentryrow');

                    var tempObj;
                    if (row.hasClass('usequickentrytemplate'))
                    {
                        var template = container.find(`#${dovPrefix}childrecordquickentrychildadd-${buttonIdParts[1]}-${buttonIdParts[2]}-Template`);
                        template.find('#ui-datepicker-div').remove();

                        //removes the ui part of the color picker that will get regenerated by the control
                        template.find('.sp-replacer').remove();
                        template.find('.colorPicker').each(function ()
                        {
                            var data = $(this).data();

                            if (Object.hasOwn(data, 'spectrum.id'))
                            {
                                data['spectrum.id'] = prefixedRowId + newRowID;
                            }
                        });

                        tempObj = template.clone(true, true);
                        var tempid = tempObj.attr('id').replace('-Template', '-' + newRowID);

                        tempObj.attr('id', tempid);

                        // Remove template's "display:none" and "doNotPost"
                        tempObj.css({ "display": "" });
                        tempObj.removeClass('doNotPost');

                        tempObj.find("[id],[name]").each(function ()
                        {
                            $(this).removeClass('doNotPost');
                        });

                        row = template;
                        newRow = tempObj;
                    }

                    newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
                    newRow.find(".help").html("");
                    newRow.find('.file').remove();

                    //Check if this is a triple nested add
                    if (button.attr('data-is-parent-of-triple') === 'true')
                    {
                        newRow.find(".childrecordquickentryrow").addClass('hidden');
                        //Manually generate a nested record to get a unique id
                        const nestedNewRowButton = newRow.find(`.js-childrecordquickentry[id^='${dovPrefix}childrecordquickentryaddbutton-']`).first();
                        generateNewRow(nestedNewRowButton, dovPrefix);
                        newRow.find(".childrecordquickentryrow.hidden").remove();
                    }
                    else
                    {
                        newRow.find(".childrecordquickentryrow").removeClass('hidden');
                    }

                    var tableSelector = `table#${dovPrefix}childrecordquickentrytable-${buttonIdParts[1]}-${buttonIdParts[2]} > tbody`;
                    var popupSelector = $('.workflowContent');

                    initializeElementsAndData(newRow, newRowID, container, row, false, rowParentRows);
                    if (newTemplateRow !== null)
                    {
                        initializeElementsAndData(newTemplateRow, newRowID, container, row, false, rowParentRows);
                    }

                    newRow.hide();
                    if (nestedRepeater.length)
                    {
                        newRow.appendTo(nestedRepeater);
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(nestedRepeater);
                        }
                    }
                    else
                    {
                        newRow.appendTo(mainDiv.find(tableSelector));
                        if (newTemplateRow !== null)
                        {
                            newTemplateRow.appendTo(mainDiv.find(tableSelector));
                        }
                    }

                    // Toggle the new row to be shown as it should now be initialized
                    newRow.show();

                    skyward.events.applyLoadActionClass(newRow);

                    skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);
                    var addButtonHeight = addButton.height();
                    var newRowHeight = newRow.height();

                    skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

                    if (button.data() && button.data('skipFocus') == true)
                    {
                        button.removeData('skipFocus');
                    }
                    else
                    {
                        const focusElement = newRow.find(":focusable").first();
                        if (focusElement.is(".datePicker"))
                        {
                            focusElement.attr("data-suppress-focus", "true");
                        }
                        focusElement.focus();

                        if (popupSelector.length > 0 && (newRow.offset().top + newRowHeight) > (popupSelector.offset().top + (popupSelector.height() - addButtonHeight)))
                        {
                            popupSelector.animate({ scrollTop: (popupSelector.scrollTop() + newRowHeight + addButtonHeight) }, 500);
                        }
                    }

                    if (newRow != null && newRow.length > 0 && newRow[0] != null)
                    {
                        newRow.removeClass('hidden');
                    }

                    button.trigger('childrecordquickentry-row-added', [newRow]);
                    maxNumberAdded(newRow);

                    newRow.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
                    {
                        var element = $(this);
                        element.addClass('alreadyGeneratedEmptyRows');
                        var extraRows = element.data().emptyRowCount;

                        for (var i = 1; i < extraRows; i++)
                        {
                            element.find('.button').click();
                        }
                    });

                    if (newTemplateRow !== null)
                    {
                        newTemplateRow.find(".DefaultComboBoxSet")
                            .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                    }
                    newRow.find(".DefaultComboBoxSet")
                        .each(function () { skyward.workflowTemplate.defaultComboBoxSetup($(this)); });
                };

                addButton.off().on('click', function () { generateNewRow($(this)); });
            });

            container.find('table.childrecordquickentrytable').each(function ()
            {
                maxNumberAdded($(this).first('tr.childrecordquickentryrow').not(".removedElement"));
            });

            container.find('div.childrecordquickentryadddiv').not(".alreadyGeneratedEmptyRows").each(function ()
            {
                var element = $(this);
                element.addClass('alreadyGeneratedEmptyRows');
                var extraRows = element.data().emptyRowCount;

                for (var i = 1; i < extraRows; i++)
                {
                    var button = element.find('.button');

                    button.data('skipFocus', true);
                    button.click();
                }
            });

            container.find('input.percentageTextBox').each(function ()
            {
                calculatePercent($(this));
            });
            container.find('input.multiplicationTextBox').each(function ()
            {
                performMultiplication($(this));
            });
            container.find('.js-childrecordquickentryerrorlabel').each(function ()
            {
                var element = $(this);

                var parentChildRecordQuickEntryRow = element.parents('.childrecordquickentryrow');
                if (parentChildRecordQuickEntryRow.length > 0)
                {
                    var elementMessageID = element.attr('data-validate-message-for');
                    var thisIDParts = elementMessageID.split('-');
                    var errorName = thisIDParts[thisIDParts.length - 1];
                    element.attr('data-validate-message-for', parentChildRecordQuickEntryRow.getIdAndPrefix().id + '-' + errorName);
                }
            });
        };

        var getTopCRQEContainerFromElement = function (element)
        {
            return element.parents(".childrecordquickentry").last();
        };

        skyward.childrecordquickentry.addressFlagCheck = function (input, clear)
        {
            var container = input.closest(".childrecordquickentry");
            var flagClicked = input;
            var flagValue = skyward.controls.getValue(flagClicked);
            var id = flagClicked.attr('id').split("-")[0];
            if (flagValue)
            {
                container.find('[id^="' + id + '"]').each(function ()
                {
                    var element = $(this);
                    skyward.controls.setValue(element, false, true);
                    skyward.controls.enable(element);
                });
                skyward.controls.setValue(flagClicked, true, true);
                skyward.controls.disable(flagClicked);
            }
            if (flagValue == "")
            {
                var parentRow;
                var parentTable;
                var firstRow;
                if (clear)
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var firstRowFlag = firstRow.find('[id^="' + id + '"]');
                    skyward.controls.setValue(firstRowFlag, true, true);
                    skyward.controls.disable(firstRowFlag);
                }
                else
                {
                    parentRow = flagClicked.parent('td').parent('tr');
                    parentTable = parentRow.parent('tbody');
                    firstRow = parentTable.find('.childrecordquickentryrow').first();
                    var firstNewRow = parentTable.find('.newchildrecordquickentryrow-1').first();
                    var rowCount = parentTable.children().length;
                    if (firstNewRow.attr('id') == firstRow.attr('id') && rowCount < 3)
                    {
                        var firstNewRowFlag = firstNewRow.find('[id^="' + id + '"]');
                        skyward.controls.setValue(firstNewRowFlag, true, true);
                        skyward.controls.disable(firstNewRowFlag);
                    }
                }
            }
        };

        var getUniqueRowID = function (container)
        {
            var childRows = container.find(".js-topchildrecordquickentry").find(".js-childrecordquickentrychild,.js-childrecordquickentrychildadd");
            var newRowID = 0;
            for (var i = 0; i < childRows.length; i++)
            {
                var childRowIDParts = childRows[i].id.split('-');
                var childRowID = parseInt(childRowIDParts[childRowIDParts.length - 1]);
                if (!isNaN(childRowID) && childRowID > newRowID)
                {
                    newRowID = childRowID;
                }
            }
            return newRowID + 1;
        };

        var initializeCounter = function (legendContentDiv, prefixedRowId)
        {
            var tbody = legendContentDiv.find('table').find('tbody');

            var tableRows = tbody.find('tr.childrecordquickentryrow.js-childrecordquickentrychildadd[id^="' + prefixedRowId + '"]');
            var nextHighestRowNum = 0;

            for (var i = 0; i < tableRows.length; i++)
            {
                var tableRow = $(tableRows[i]);
                var rowToEvaluate = tableRow.attr("id").split("-");
                var rowNum = rowToEvaluate[rowToEvaluate.length - 1];
                nextHighestRowNum = Math.max(parseInt(rowNum, 10), nextHighestRowNum);
            }

            return nextHighestRowNum;
        };

        var initializeElementsAndData = function (newRow, counter, container, row, preservePrefilledValues, rowParentRows, crqeRecordValues)
        {
            var idPrefix = container.getIdAndPrefix().prefix;
            var elementTypesToInitialize = ['label', '.fieldWrapper', 'div', 'span', 'a', ':input', 'option', '.dateTimePickerWrapper'];
            var dataTypesToCheck = ["validate-message-for", "validate-control-for", "validate-text-for", "dependents", "dynamicfiltervalue"];
            const defaultValueInputsToIgnore = ["codeEELCode", "codeEELDescription", "tileViewEEL_search"];

            var dataElements = [];
            var elementsToInitialize = [];

            // If there are any CodeEELs in the newly cloned row, we need to remove the initialized value EEL data
            newRow.find(".codeEELValue").each(function ()
            {
                $(this).removeData('eel-data');
            });

            newRow.find(getElementAndDataAttributeSelector(elementTypesToInitialize, dataTypesToCheck)).each(function ()
            {
                var element = $(this);
                var index;
                // TODO having two loops is silly, we should just do two separate .find().each() calls
                for (index in dataTypesToCheck)
                {
                    if (element.data(dataTypesToCheck[index]) != undefined)
                    {
                        dataElements.push(this);
                    }
                }

                for (index in elementTypesToInitialize)
                {
                    if (element.is(elementTypesToInitialize[index]))
                    {
                        elementsToInitialize.push(this);
                    }
                }
            });

            var combineElementAndGrandparentIds = function (grandparentIdParts, elementId)
            {
                // First part of dependent ID should be equal if parent ID was already prepended
                if (elementId.indexOf("-add-") >= 0 && grandparentIdParts[0] === "childrecordquickentrychild")
                {
                    // Need to find some way to elimate the duplicated id when the grandparent id is the same as the child (happens only with triple nested)
                    grandparentIdParts[0] = grandparentIdParts[0].concat("add");
                    var newGrandparentId = grandparentIdParts.join("-");
                    // With triple nested the first part of the id of the child record is the same as the grandparent
                    // (I think its being generated like that in crqe.cs somewhere, but this is a workaround for now)
                    if (elementId.length >= newGrandparentId.length && elementId.startsWith(newGrandparentId))
                    {
                        return elementId;
                    }
                }

                elementId = grandparentIdParts.join("-") + '-' + elementId;

                return elementId;
            };

            $.each(dataElements, function ()
            {
                let input = $(this);

                let parentRepeaterRows = input.parents('tr.childrecordquickentryrow');
                const parentRepeater = parentRepeaterRows.first();

                // parentRepeaterRows will only contain grandparent rows when we're adding the outer and nested row at the same time...
                // ...if we're adding a just a nested row then when need to get the old row's parent rows and merge that with the input's parents
                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                const isNestedRepeaterElement = parentRepeaterRows.length > 1;

                const parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                let parentCounter = null;
                let innerCounter = counter;

                const repeaterGrandparent = parentRepeaterRows.eq(1);
                const { id: grandparentId, prefix: grandparentPrefix } = repeaterGrandparent.getIdAndPrefix(idPrefix);
                const grandparentParts = grandparentId?.split("-") ?? [];

                if (input.hasClass("js-maskInitialized"))
                {
                    input.removeClass("js-maskInitialized");
                }

                if (input.hasClass("masked"))
                {
                    input.removeClass("masked");
                }

                if (isNestedRepeaterElement)
                {
                    // outer (grandparent row) quick entry
                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    // nested (parent row) quick entry
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                for (let index in dataTypesToCheck)
                {
                    if (dataTypesToCheck[index] === "dependents")
                    {
                        const dependentAttribute = input.attr("data-" + dataTypesToCheck[index]);
                        if (dependentAttribute != undefined)
                        {
                            const dependentObject = JSON.parse(dependentAttribute);
                            const dependents = dependentObject.dependents;
                            const isInnerChildRecordQuickEntry = dependentObject.isInnerChildRecordQuickEntry;
                            for (let dependentIndex in dependents)
                            {
                                let dependentId = dependents[dependentIndex].Id;
                                const grandParentIndexes = [];
                                let grandParentIndexCounter = 0;

                                if (dependentId != undefined)
                                {
                                    const dependentIdHasPrefix = dependentId.startsWith(idPrefix);

                                    if (dependentIdHasPrefix)
                                    {
                                        dependentId = dependentId.slice(idPrefix.length);
                                    }

                                    if (isInnerChildRecordQuickEntry && isNestedRepeaterElement)
                                    {
                                        for (var x = 0; x < grandparentParts.length; x++)
                                        {
                                            if (!isNaN(grandparentParts[x]))
                                            {
                                                grandParentIndexes[grandParentIndexCounter] = grandparentParts[x];
                                                grandParentIndexCounter++;
                                            }
                                        }
                                        grandParentIndexCounter = 0;
                                    }

                                    let dependentIdParts = dependentId.split('-');
                                    let dependentIdPartsLength = dependentIdParts.length;
                                    // First part of dependant ID should be equal if parent ID was already prepended
                                    if (isNestedRepeaterElement && dependentIdPartsLength > 0 && grandparentParts.length > 0 && grandparentParts[0] != dependentIdParts[0] && (grandparentParts[0] + "add") != dependentIdParts[0])
                                    {
                                        if (dependentId.indexOf('-add-') >= 0 && grandparentParts[0] === "childrecordquickentrychild")
                                        {
                                            grandparentParts[0] = grandparentParts[0].concat("add");
                                        }

                                        dependentId = grandparentParts.join('-') + '-' + dependentIdParts.join('-');
                                    }

                                    dependentIdParts = dependentId.split('-');
                                    dependentIdPartsLength = dependentIdParts.length;
                                    let updatedDependentId = '';

                                    if (isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (var l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            if (isNaN(dependentIdParts[l]))
                                            {
                                                updatedDependentId += dependentIdParts[l] + '-';
                                            }
                                            else
                                            {
                                                updatedDependentId += grandParentIndexes[grandParentIndexCounter] + '-';
                                                grandParentIndexCounter++;
                                            }
                                        }

                                        updatedDependentId += innerCounter;
                                    }
                                    else if (!isInnerChildRecordQuickEntry && dependentIdPartsLength > 1)
                                    {
                                        for (let l = 0; l < dependentIdPartsLength - 1; l++)
                                        {
                                            updatedDependentId += dependentIdParts[l] + '-';
                                        }

                                        updatedDependentId += innerCounter;
                                    }

                                    if (dependentIdHasPrefix)
                                    {
                                        updatedDependentId = `${idPrefix}${updatedDependentId}`;
                                    }

                                    dependents[dependentIndex].Id = updatedDependentId;
                                }
                            }
                            dependentObject.dependents = dependents;

                            input.data(dataTypesToCheck[index], dependentObject);
                            input.attr('data-' + dataTypesToCheck[index], JSON.stringify(dependentObject));
                        }
                    }
                    else
                    {
                        skyward.ajax.unregisterControlAjax(input);

                        let nonDependentDataTypesToCheck = input.data(dataTypesToCheck[index]);

                        if (nonDependentDataTypesToCheck !== null && typeof nonDependentDataTypesToCheck === 'string')
                        {
                            let nonDependentCounter = innerCounter;

                            if (isNestedRepeaterElement && dataTypesToCheck[index] !== 'dynamicfiltervalue' &&
                                nonDependentDataTypesToCheck.split('-').length > 0 && grandparentParts[0] != nonDependentDataTypesToCheck.split('-')[0])
                            {
                                // First part of dependent ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                                nonDependentDataTypesToCheck = combineElementAndGrandparentIds(grandparentParts, nonDependentDataTypesToCheck);
                            }

                            // Nested repeaters may have dependencies at other levels of nesting and require special handling
                            if (isNestedRepeaterElement && dataTypesToCheck[index] === 'dynamicfiltervalue')
                            {
                                const dependencyParentRow = $('[name="' + nonDependentDataTypesToCheck + '"]').last().parents('tr.childrecordquickentryrow');
                                if (dependencyParentRow.length > 0 && dependencyParentRow.length !== parentRepeaterRows.length)
                                {
                                    // TODO: this assumes that because the dependency element is on a different level it is in the parent repeater
                                    // this works for 1 nested repeater, but will break when the dependency is more than 1 nested repeater up (or down) the hierarchy
                                    nonDependentCounter = parentCounter;
                                }
                                // If the dependency doesn't "exist" yet, assume it's in the parent
                                else if (dependencyParentRow.length === 0)
                                {
                                    nonDependentCounter = parentCounter;
                                }
                            }

                            let dataTypeValue = '';

                            if (input.hasClass('js-childrecordquickentryerrorlabel'))
                            {
                                continue;
                            }
                            //allow for multiple dependents
                            let dynamicfiltervalueParts = null;
                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                dynamicfiltervalueParts = nonDependentDataTypesToCheck.split(',');
                            }

                            if (dynamicfiltervalueParts != null && dynamicfiltervalueParts.length > 1)
                            {
                                for (let i = 0; i < dynamicfiltervalueParts.length; i++)
                                {
                                    if (dataTypeValue != '')
                                    {
                                        dataTypeValue += ',';
                                    }
                                    dataTypeValue += processDataTypeValue(dynamicfiltervalueParts[i], parentIdParts, parentCounter, nonDependentCounter);
                                }
                            }
                            else
                            {
                                dataTypeValue = processDataTypeValue(nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter);
                            }

                            if (dataTypesToCheck[index] === "dynamicfiltervalue")
                            {
                                input.data(dataTypesToCheck[index], dataTypeValue);
                            }

                            input.attr("data-" + dataTypesToCheck[index], dataTypeValue);
                        }
                    }
                }
            });

            $.each(elementsToInitialize, function ()
            {
                var element = $(this);
                var { id: elementId } = element.getIdAndPrefix(idPrefix);
                var parentRepeaterRows = element.parents('tr.childrecordquickentryrow');
                var parentRepeater = parentRepeaterRows.first();

                if (rowParentRows)
                {
                    $.merge(parentRepeaterRows, rowParentRows);
                }

                var isNestedRepeaterElement = parentRepeaterRows.length > 1;
                var parentIdParts = isNestedRepeaterElement && parentRepeater.attr('id') ? parentRepeater.attr('id').split('-') : [];
                var parentCounter = null;
                var innerCounter = counter;

                // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
                var clonevalue = getDataClonevalue(element);

                if (isNestedRepeaterElement)
                {
                    var repeaterGrandparent = parentRepeaterRows.eq(1);
                    var grandparentParts = repeaterGrandparent.attr('id') ? repeaterGrandparent.attr('id').split('-') : [];

                    parentCounter = grandparentParts[grandparentParts.length - 1];
                    innerCounter = parentIdParts[parentIdParts.length - 1];
                }

                var newId = '';
                var oldId = '';
                var newName = '';

                if (elementId != null)
                {
                    var parseIdOrName = function (attribute)
                    {
                        var newValue = '';
                        var idPostfix = '';

                        var repeaterGrandparent = parentRepeater.parents('tr.childrecordquickentryrow').not(".disablenestedrepeaterrename").first();
                        var grandparentParts = repeaterGrandparent.getIdAndPrefix(idPrefix).id?.split('-') ?? null;
                        // First part of attribute ID should be equal if parent ID was already prepended, to ensure we have a childrecordquickentrychildadd id on the new row
                        if (repeaterGrandparent && repeaterGrandparent.attr('id') && grandparentParts && attribute.split('-').length > 0 && grandparentParts[0] != attribute.split('-')[0])
                        {
                            attribute = combineElementAndGrandparentIds(grandparentParts, attribute);
                        }

                        var attributeParts = attribute.split('-');

                        var idLength = attributeParts.length;
                        var postFixedParts = attributeParts[idLength - 1].split('_');
                        var postFixedPartsLength = postFixedParts.length;

                        if (postFixedPartsLength > 1)
                        {
                            for (var j = 1; j < postFixedPartsLength; j++)
                            {
                                idPostfix += '_' + postFixedParts[j];
                            }
                        }

                        if (idLength > 1)
                        {
                            for (var i = 0; i < idLength - 1; i++)
                            {
                                if (parentIdParts && i === parentIdParts.length - 1 && skyward.extensions.isNumeric(parentIdParts[i]))
                                {
                                    newValue = newValue + parentCounter + '-';

                                    if (!skyward.extensions.isNumeric(attributeParts[i]) && attributeParts[i] !== 'Template')
                                    {
                                        newValue = newValue + attributeParts[i] + '-';
                                    }
                                }
                                else
                                {
                                    newValue = newValue + attributeParts[i] + '-';
                                }
                            }
                        }
                        else
                        {
                            newValue = attributeParts[0] + '-';
                        }

                        var newIdValue = newValue + innerCounter;

                        return newIdValue + idPostfix;
                    };

                    oldId = idPrefix + elementId;
                    newId = parseIdOrName(elementId);

                    if (element.attr('name'))
                    {
                        newName = parseIdOrName(element.attr('name'));
                    }
                    else if (element.hasClass("radioButtonGroup"))
                    {
                        // radio button groups utilize a data-name attribute on the container element
                        newName = parseIdOrName(element.data('name'));
                    }

                    const newElementID = idPrefix + newId;

                    newRow.find(`[for='${oldId}']`).attr('for', newElementID);
                    newRow.find(`[aria-labelledby='${oldId}']`).attr('aria-labelledby', newElementID);
                    newRow.find(`[aria-describedby='${oldId}']`).attr('aria-describedby', newElementID);

                    skyward.controls.changeId(element, newElementID, newName);
                }

                var parent = element.parent();
                let valueHasBeenSet = false;
                if (element.hasClass('codeEELValue') || element.hasClass('tileViewEEL_value'))
                {
                    parent.off();
                    element.off();
                    var newParentID = '';
                    var { id: oldParentId } = parent.getIdAndPrefix(idPrefix);
                    var inputIdPartsEELParent = oldParentId.split("-");

                    if (inputIdPartsEELParent.length > 1)
                    {
                        newParentID = inputIdPartsEELParent.slice(0, -1).join("-") + "-";
                    }
                    else
                    {
                        newParentID = inputIdPartsEELParent[0] + '-';
                    }

                    const previousParentID = newParentID + (innerCounter - 1);
                    newParentID = newParentID + innerCounter;

                    const newID = idPrefix + newParentID;

                    newRow.find(`[for='${oldParentId}']`).attr('for', newID);
                    newRow.find(`[aria-labelledby='${oldParentId}']`).attr('aria-labelledby', newID);
                    newRow.find(`[aria-describedby='${oldParentId}']`).attr('aria-describedby', newID);

                    parent.data("original-id", parent.attr("id"));
                    parent.attr('id', newID);
                    if (element.hasClass('codeEELValue'))
                    {
                        parent.data('area', element.data('area'));
                        parent.data('action', element.data('action'));
                        parent.data('controller', element.data('controller'));
                        parent.data('securityHash', element.data('securityHash'));
                        var eelHasPostdata = !$.isEmptyObject(parent.data("postdata"));
                        var eelDynamicHashData = parent.find(".codeEELValue").data("dynamic-filter-hashes");
                        if (eelHasPostdata && eelDynamicHashData?.PageStateModifyControlValue === null && eelDynamicHashData.PageStateModifyControlCode === null && eelDynamicHashData.PageStateModifyControlDescription === null)
                        {
                            // Used in Out of District Transfer Course workflow
                            const dynamicPageStateValues = {
                                PageStateModifyControlValue: idPrefix + newParentID,
                                PageStateModifyControlCode: idPrefix + newParentID + "_code",
                                PageStateModifyControlDescription: idPrefix + newParentID + "_description"
                            };
                            const additionalDynamicFilterValues = $.extend({}, parent.data("additionalDynamicFilterValues"), dynamicPageStateValues);
                            parent.data("additionalDynamicFilterValues", additionalDynamicFilterValues);
                            parent[0].dataset.additionalDynamicFilterValues = JSON.stringify(additionalDynamicFilterValues);
                        }
                        skyward.codeeel.reinitializeCodeEEL(parent);
                    }
                    else
                    {
                        // Handle cloning the request data hash for TileViewEEL on new rows
                        const previousParent = container.find(`#${previousParentID}`);
                        if (previousParent.length > 0)
                        {
                            const searchElement = previousParent.find(".tileViewEEL_search");
                            const valueElement = previousParent.find(".tileViewEEL_value");
                            const elementRequestDataHashSrc = searchElement.data().requestDataHashSrc;
                            const hashKey = valueElement.attr("name");
                            const requestDataHashes = skyward.requestDataHash.getRequestDataHashes(elementRequestDataHashSrc);
                            const requestDataHash = skyward.requestDataHash.getRequestDataHash(elementRequestDataHashSrc, hashKey);
                            if (requestDataHash)
                            {
                                const newValueElement = parent.find(".tileViewEEL_value");
                                const newTrueId = newValueElement.attr("name");
                                requestDataHashes[newTrueId] = $.extend(true, {}, requestDataHash);
                                newValueElement.data("original-name", newTrueId);
                            }
                        }

                        parent.find(".tileViewEEL_search").off();
                        parent.find(".tileViewEEL_searchButton").off();
                        skyward.tileViewEEL.registerTileViewEEL(parent);
                    }

                    if (!preservePrefilledValues)
                    {
                        //TODO: right now I have it so it looks for the label above the code eel to have an attr of
                        //data-clonevalue, will have to fix code eels or think of a better way of doing this
                        if (clonevalue)
                        {
                            // TODO: tileEEL containing div has the same ID as the TileEEL hidden field, this selector always selects the input instead of the div
                            skyward.controls.copyValue($(`[id="${oldId}"]:input`), parent, true);
                        }
                        else
                        {
                            skyward.controls.setValue(parent, null, true);
                        }

                        valueHasBeenSet = true;
                    }

                    skyward.controls.changeId(parent, idPrefix + newParentID);
                }

                if (element.hasClass('dmsBackingData'))
                {
                    parent.off();
                    parent.find('.distinctMultiSelectUserInput').off();
                    element.off();
                    parent.attr('data-hidden-backing-data-id', element.attr('id'));
                    parent.data('hidden-backing-data-id', element.attr('id'));
                    parent.data('selected-item-keys', []);
                    parent.data('dmseInstance', null);

                    parent.removeClass("eventsBound--DMSE");
                    skyward.distinctMultiSelectEEL.registerDistinctMultiSelectEEL(parent);

                    if (!clonevalue && !getDataClonevalue(element.parent()))
                    {
                        skyward.distinctMultiSelectEEL.values.clear(parent);
                    }
                }

                if (element.hasClass('datepicker'))
                {
                    parent.attr('id', 'disciplineDateSpan-' + innerCounter);
                    skyward.datepicker.destroy(element);
                    var calendarButton = parent.children('.datepicker-trigger');
                    calendarButton.attr('id', newId + '-icon');
                    skyward.datepicker.registerDatepicker(element);
                }

                if (!preservePrefilledValues && !valueHasBeenSet && element.is(':input') && !defaultValueInputsToIgnore.some(className => element.hasClass(className)))
                {
                    let defaultValue = clonevalue ? element.attr('data-original-value') : null;

                    if (element.is(":checkbox"))
                    {
                        defaultValue = defaultValue === "true";
                    }
                    else if (element.is(":radio"))
                    {
                        var radioNameOld = element.attr("Name");
                        var lastIndexOfDash = radioNameOld.lastIndexOf('-');
                        var radioName = radioNameOld.substring(0, lastIndexOfDash);

                        element.attr("Name", radioName + "-" + innerCounter);
                        if (element.parents('.radioButtonGroup').eq(0).find('.radioButtonGroupValue').length)
                        {
                            element.attr("Name", element.attr('Name') + 'child');
                        }
                        if (element[0].defaultChecked === true)
                        {
                            defaultValue = element[0].defaultValue;
                        }
                    }

                    if (element.is(".datePicker,.timePicker,.dateTimePicker"))
                    {
                        const control = element.closest(".dateTimePickerWrapper");
                        let originalValue = control.attr('data-original-value')?.substring(0, 10);
                        let defaultValue = clonevalue ? originalValue : null;
                        control.val(defaultValue);
                    }
                    else
                    {
                        skyward.controls.setValue(element, defaultValue, true);
                    }
                    //Setting value clears select inputs out, since they are directly using .val()
                    if (element.is("select"))
                    {
                        $(row).find("select").each(function (currentIndex)
                        {
                            $(this).find("select").eq(currentIndex).val(defaultValue);
                        });
                    }
                }

                // crqeRecordValues is set from ajax, so we expect unprefixed ids
                // technically it checks id.indexOf(value) so we're probably fine either way
                setCRQERecordValues(crqeRecordValues, element, elementId);

                // Default new control
                let elementWithCloneData = element;
                if (element.is(".datePicker,.timePicker,.dateTimePicker"))
                {
                    elementWithCloneData = element.closest(".dateTimePickerWrapper");
                }
                const elementHasCloneValue = elementWithCloneData.attr('data-clonevalue') != null && elementWithCloneData.attr('data-clonevalue').toLowerCase() != "false";

                if (element.is(':input') && elementHasCloneValue)
                {
                    var oldElement = document.getElementById(oldId);
                    if (oldElement !== null)
                    {
                        // TODO: Remove this check after PR 6145635
                        if (element.hasClass('datepicker'))
                        {
                            var valueToSet;
                            if (!oldElement.value || (oldElement.value.length < 10 && !skyward.validation.validDate(oldElement.value.substring(0, 10))))
                            {
                                valueToSet = null;
                            }
                            else if (elementWithCloneData.attr('data-incrementcloneddate') != null && elementWithCloneData.attr('data-incrementcloneddate').toLowerCase() != "false")
                            {
                                const date = skyward.controls.getValue(oldElement);
                                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                newDate.setDate(date.getDate() + 1);

                                valueToSet = date;
                            }
                            else
                            {
                                valueToSet = skyward.controls.getValue(oldElement);
                            }
                            skyward.controls.setValue(element, valueToSet, true);
                            skyward.datepicker.setDatePicker(element);
                        }
                        else if (element.hasClass('datePicker'))
                        {
                            let valueToSet;
                            if (!oldElement.value || (oldElement.value.length < 10 && !skyward.validation.validDate(oldElement.value.substring(0, 10))))
                            {
                                valueToSet = null;
                            }
                            else if (elementWithCloneData.attr('data-incrementcloneddate') != null && elementWithCloneData.attr('data-incrementcloneddate').toLowerCase() != "false")
                            {
                                const date = skyward.controls.getValue(oldElement);
                                const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                                newDate.setDate(date.getDate() + 1);

                                valueToSet = newDate;
                            }
                            else
                            {
                                valueToSet = skyward.controls.getValue(oldElement);
                            }
                            elementWithCloneData.val(valueToSet?.toISOString());
                        }
                        else
                        {
                            skyward.controls.setValue(element, skyward.extensions.decodeHtml(skyward.controls.getValue(oldElement)), true);
                        }
                    }
                }

                //Screen specific
                //TODO: See if there is a way we can check what this thing belongs to, and run a custom javascript function from a different file, but genericise it
                if (element.hasClass('honorrollmethodisactivecheckbox '))
                {
                    element.click(function ()
                    {
                        skyward.grading.honorRollMethodDefaultValueFunction($(this));
                    });
                }

                if (element.hasClass('AddressFlag'))
                {
                    var flagOnChange = function ()
                    {
                        skyward.childrecordquickentry.addressFlagCheck($(this), false);
                    };
                    element.on('change', flagOnChange);
                }

                if (element.hasClass('manualEntryCheckbox'))
                {
                    element.attr('data-clonevalue', 'true');
                }

                // Add the control
                var dataObjectViewer = container.find('div.contentArea div.currentRecordContent.dataObjectViewer');
                var dovId = dataObjectViewer.attr('id');

                skyward.dataobjectviewer.addNewControl(dovId, false);
            });
            processedIds.push(newRow.attr('id'));
            skyward.datamask.applyMaskOnContainer(container);
        };

        var processDataTypeValue = function (nonDependentDataTypesToCheck, parentIdParts, parentCounter, nonDependentCounter)
        {
            var dataTypeValue = '';
            var dataTypesForParts = nonDependentDataTypesToCheck.split('-');
            var dataTypesForPartsLength = dataTypesForParts.length;

            if (dataTypesForPartsLength > 1)
            {
                for (var k = 0; k < dataTypesForPartsLength - 1; k++)
                {
                    if (parentIdParts && k === parentIdParts.length - 1 && skyward.extensions.isNumeric(parentIdParts[k]))
                    {
                        dataTypeValue += parentCounter + '-';
                    }
                    else
                    {
                        dataTypeValue += dataTypesForParts[k] + '-';
                    }
                }

                dataTypeValue += nonDependentCounter;
            }
            else if (dataTypesForPartsLength === 1)
            {
                dataTypeValue = dataTypesForParts[0];
            }
            return dataTypeValue;
        };

        var getElementAndDataAttributeSelector = function (elementTypes, dataAttributes)
        {
            var selectorString = elementTypes.join(',');

            if (dataAttributes && dataAttributes.length > 0)
            {
                selectorString += ',';

                selectorString += dataAttributes.reduce(function (previous, current, index, array)
                {
                    return previous + '[data-' + current + ']' + (index === array.length - 1 ? '' : ',');
                }, "");
            }

            return selectorString;
        };

        var fixSuffix = function (childParts, adjustedParentParts)
        {
            var underscoredSuffix = childParts[childParts.length - 1].split('_');
            var updatedParts = childParts;
            updatedParts[updatedParts.length - 1] = adjustedParentParts[adjustedParentParts.length - 1];
            var updatedPart = updatedParts.join('-');
            if (underscoredSuffix.length === 2)
            {
                updatedPart = updatedPart + '_' + underscoredSuffix[1];
            }
            return updatedPart;
        };

        var initializeChildRecordIDs = function (row)
        {
            var elementTypesToInitialize = ['label', 'fieldset', 'div', 'span', 'a', ':input'];
            var parent = row instanceof $ ? row : $(row);
            var { id: parentId, prefix: dovPrefix } = parent.getIdAndPrefix();
            var parentIdParts = parentId?.split('-');

            if (parentId)
            {
                parent.find('tr.childrecordquickentryrow').find(getElementAndDataAttributeSelector(elementTypesToInitialize)).each(function ()
                {
                    var element = $(this);
                    var elementParent = element.parent();

                    var { id: childId } = element.getIdAndPrefix(dovPrefix);
                    var childName = element.attr('name');
                    if (childId)
                    {
                        var childIdParts = childId.split('-');
                        var updatedId;

                        var adjustedParentIdParts = parentIdParts?.slice();
                        // TODO `adjustedParentIdParts[0] === 'childrecordquickentrychild'` should always be true for rows, unless they've already been modified
                        // and this method is only called on rows
                        // if the element is an add button, adjust its prefix so it acts like a top-level add button?
                        if (adjustedParentIdParts[0] === 'childrecordquickentrychild' && childIdParts.length >= 2 && childIdParts[childIdParts.length - 2] === 'add')
                        {
                            adjustedParentIdParts[0] = 'childrecordquickentrychildadd';
                        }
                        var adjustedParentId = adjustedParentIdParts.join('-');

                        if (childIdParts.length >= 4)
                        {
                            updatedId = fixSuffix(childIdParts, adjustedParentIdParts);
                        }
                        else
                        {
                            updatedId = adjustedParentId + '-' + childId;
                        }

                        if (childName)
                        {
                            var childNameParts = childName.split('-');
                            var updatedName;
                            if (childIdParts.length >= 4)
                            {
                                updatedName = fixSuffix(childNameParts, adjustedParentIdParts);
                            }
                            else
                            {
                                updatedName = adjustedParentId + '-' + childName;
                            }

                            var dataAction = element.attr('data-action');

                            if (dataAction && (dataAction === 'codeEEL' || dataAction === 'tileViewEEL'))
                            {
                                elementParent.siblings('span[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                elementParent.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                // Update codeEEL Code/Description boxes
                                element.siblings('input[data-validate-control-for]').each(function ()
                                {
                                    $(this).attr('data-validate-control-for', updatedName);
                                });
                            }
                            else
                            {
                                element.siblings('span[data-validate-message-for]').each(function ()
                                {
                                    $(this).attr('data-validate-message-for', updatedName);
                                });

                                element.siblings('label[data-validate-text-for]').each(function ()
                                {
                                    $(this).attr('data-validate-text-for', updatedName);
                                });

                                if (element.attr('data-validate-control-for'))
                                {
                                    element.attr('data-validate-control-for', updatedName.replace('_code', '').replace('_description', ''));
                                }
                            }

                            element.data("original-name", element.data("original-name") ?? updatedName);
                            element.attr('name', updatedName);
                        }

                        element.attr('id', dovPrefix + updatedId);
                    }
                });
            }
        };

        function getDataClonevalue(element)
        {
            let elementToUse = element;
            if (elementToUse.hasClass("codeEELCode") || elementToUse.hasClass("codeEELDescription"))
            {
                elementToUse = element.closest(".codeEEL").find(".codeEELValue");
            }
            const eelLabel = elementToUse.parent().siblings('label[data-validate-text-for]').first();

            // true if element has data-clonevalue true or if the code/tile EEL's text-for label has clonevalue true
            return (elementToUse.attr('data-clonevalue') && elementToUse.attr('data-clonevalue').toLowerCase() === 'true') ||
                ((elementToUse.hasClass('codeEELValue') || elementToUse.hasClass('tileViewEEL_value') || elementToUse.hasClass('dmsBackingData')) &&
                    eelLabel !== elementToUse && eelLabel.length && eelLabel.attr('data-clonevalue') && eelLabel.attr('data-clonevalue').toLowerCase() === "true") ||
                (elementToUse.attr('data-clonevalue') && elementToUse.hasClass('childRecordValueClonable')) ||
                (element.hasClass('datePicker') && getDataClonevalue(element.closest("sky-datepicker"))) ||
                (elementToUse.hasClass('radioButtonGroupValue') && getDataClonevalue(elementToUse.parent()));
        }

        var getDataTakeDefaultValue = function (element)
        {
            var data = element.data();
            return String(data.takedefaultvalue).toLowerCase() === 'true';
        };

        var maxNumberAdded = function (rowPart)
        {
            var table = $(rowPart).closest('table.childrecordquickentrytable');
            var maxNumber = table.attr('data-limitnumberofadds');

            if (maxNumber)
            {
                var counter = $(table).children('tbody').children('tr.childrecordquickentryrow').not(".removedElement").length;
                var addButtonDiv = $(table).siblings('div.childrecordquickentryadddiv');

                if (counter >= maxNumber)
                {
                    addButtonDiv.find('a').addClass("hidden");
                }
                else if (addButtonDiv.find('a.hidden').length)
                {
                    addButtonDiv.find('a.hidden').removeClass("hidden");
                }
            }
        };

        var performMultiplication = function (multiplicationTextBox)
        {
            var multiplierParentFieldName = multiplicationTextBox.attr('data-multiplierparent');
            var multiplierParent = multiplicationTextBox.closest(".fieldWrapper").siblings().children('input[name="' + multiplierParentFieldName + '"]');

            var thisFieldsName = multiplicationTextBox.attr('name').substring(0, multiplicationTextBox.attr('name').indexOf('-'));

            var multiplierChildFieldName = multiplicationTextBox.attr('data-multiplierchild');
            multiplierChildFieldName = multiplicationTextBox.attr('name').replace(thisFieldsName, multiplierChildFieldName);
            var multiplierChild = multiplicationTextBox.parent().siblings().children('[name="' + multiplierChildFieldName + '"]');

            if (!multiplierParent ||
                !multiplierParent.val() ||
                !multiplierChild ||
                !multiplierChild.val())
            {
                return;
            }
            else
            {
                var multiplierChildValue = multiplierChild.val().replace(/[^\d.-]/g, '');
                if (multiplierChildFieldName.includes('Percent'))
                {
                    multiplierChildValue = multiplierChildValue / 100;
                }
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(multiplicationTextBox, (multiplierParent.val().replace(/[^\d.-]/g, '') * multiplierChildValue).toFixed(2), true);
            }
        };

        var calculatePercent = function (percentageTextBox)
        {
            var denominatorFieldName = percentageTextBox.attr('data-denominator');
            var denominator = percentageTextBox.closest(".fieldWrapper").siblings().children('input[name="' + denominatorFieldName + '"]');

            var numeratorFieldName = percentageTextBox.attr('data-numerator');
            numeratorFieldName = percentageTextBox.attr('name').replace('Percent', numeratorFieldName);
            var numerator = percentageTextBox.parent().siblings().children('[name="' + numeratorFieldName + '"]');

            if ((!denominator || !denominator.val()) &&
                (!numerator.val() && !numerator))
            {
                skyward.controls.setValue(percentageTextBox, '100.00', true);
            }
            else if (!numerator || !numerator.val() || denominator.val() == 0)
            {
                skyward.controls.setValue(percentageTextBox, "", true);
            }
            else
            {
                //regex is to strip any special characters (commas, dollar signs, etc.) except periods and dashes
                skyward.controls.setValue(percentageTextBox, ((numerator.val().replace(/[^\d.-]/g, '') / denominator.val().replace(/[^\d.-]/g, '')) * 100).toFixed(2), true);
            }
        };

        skyward.childrecordquickentry.SetCRQERecordValues = function (crqeRecord, container, idPrefix)
        {
            var crqeTableId = crqeRecord.CRQETableID.replace("#", "#" + (idPrefix ?? ""));
            var crqeTableIdParts = crqeTableId.split('-');
            var crqeTable = container.find(crqeTableId);
            var nestedRepeater = crqeTable.closest('.childrecordquickentryadddiv').prev('.childrecordquickentrytable');
            var prefixedRowId = `${idPrefix}childrecordquickentrychildadd-${crqeTableIdParts[1]}-${crqeTableIdParts[2]}-`;
            // First childrecordquickentry ancestor - never grandparent
            var mainDiv = crqeTable.parents('.childrecordquickentry').eq(0);

            // find the highest row count
            var legendContentDiv = $(".thinHeaderContainerBorder");
            var previousRowID = initializeCounter(legendContentDiv, prefixedRowId);

            var row;
            if (nestedRepeater.length)
            {
                row = nestedRepeater.find('#' + prefixedRowId + previousRowID);
            }
            else
            {
                row = mainDiv.find('#' + prefixedRowId + previousRowID);
            }
            row.find('#ui-datepicker-div').remove(); //before cloning remove the Jquery datepicker div so the clone doesn't clone into it

            var newRow = row.clone(true, true);
            var newRowID = getUniqueRowID(container);
            newRow.attr('id', prefixedRowId + newRowID);

            var rowParentRows = row.parents('tr.childrecordquickentryrow');

            if (row.hasClass('usequickentrytemplate'))
            {
                var template = container.find('#childrecordquickentrychildadd-' + crqeTableIdParts[1] + '-' + crqeTableIdParts[2] + '-Template');
                template.find('#ui-datepicker-div').remove();

                //removes the ui part of the color picker that will get regenerated by the control
                template.find('.sp-replacer').remove();
                template.find('.colorPicker').each(function ()
                {
                    var data = $(this).data();

                    if (Object.hasOwn(data, 'spectrum.id'))
                    {
                        data['spectrum.id'] = prefixedRowId + newRowID;
                    }
                });

                var tempObj = template.clone(true, true);
                var tempID = tempObj.attr('id').replace('-Template', '-' + newRowID);

                tempObj.attr('id', tempID);

                // Remove template's "display:none" and "doNotPost"
                tempObj.css({ "display": "" });
                tempObj.removeClass('doNotPost');

                tempObj.find("[id],[name]").each(function ()
                {
                    $(this).removeClass('doNotPost');
                });

                row = template;
                newRow = tempObj;
            }

            newRow.find(".error-control, .error-text, .warning-control").removeClass("error-control error-text warning-control");
            newRow.find(".help").html("");
            newRow.find('.file').remove();

            var tableSelector = `table#${idPrefix}childrecordquickentrytable-${crqeTableIdParts[1]}-${crqeTableIdParts[2]} > tbody`;

            initializeElementsAndData(newRow, newRowID, container, row, true, rowParentRows, crqeRecord.Values);

            if (nestedRepeater.length)
            {
                newRow.appendTo(nestedRepeater);
            }
            else
            {
                newRow.appendTo(mainDiv.find(tableSelector));
            }

            skyward.events.applyLoadActionClass(newRow);

            skyward.childrecordquickentry.setQuickEntryNumbersAndLetters(container);

            // TODO (5270635) test
            skyward.window.notifyDOMLoad('#' + newRow.attr("id"));

            $(crqeTableId).trigger('childrecordquickentry-row-added', [newRow]);
            maxNumberAdded(newRow);
        };

        var setCRQERecordValues = function (crqeRecordValues, element, elementId)
        {
            if (crqeRecordValues !== null && (element.is(':input:not(.codeEELCode,.codeEELDescription)') || element.hasClass("codeEEL")))
            {
                var crqeRecordValue = null;
                for (var value in crqeRecordValues)
                {
                    crqeRecordValue = null;
                    if (value.indexOf("_value") !== -1)
                    {
                        if ((element.hasClass("codeEELValue") || element.hasClass("codeEEL")) && elementId.indexOf(value.replace('_value', '')) !== -1)
                        {
                            crqeRecordValue = crqeRecordValues[value];
                            break;
                        }
                    }
                    else if ((elementId !== undefined && elementId !== null && elementId.indexOf(value) !== -1) || element.val() === crqeRecordValues[value])
                    {
                        crqeRecordValue = crqeRecordValues[value];
                        break;
                    }
                }

                if (crqeRecordValue !== null && crqeRecordValue !== undefined)
                {
                    if (element.hasClass("codeEEL"))
                    {
                        skyward.codeeel.setCodeEELValue(element, crqeRecordValue, true);
                    }
                    else if (element.is(":checkbox"))
                    {
                        crqeRecordValue = crqeRecordValue === "true";
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                    else if (element.is(":radio"))
                    {
                        var inputCheckbox = element;
                        var radioButtonGroup = inputCheckbox.parents('.radioButtonGroup');
                        if (radioButtonGroup.length)
                        {
                            if (element.val() === crqeRecordValue)
                            {
                                radioButtonGroup.find('input:checked').each(function (e, ele)
                                {
                                    $(ele).prop('checked', false);
                                });
                                skyward.controls.setValue(element, crqeRecordValue, true);
                            }
                        }
                        else
                        {
                            inputCheckbox.prop('checked', false);
                        }
                    }
                    else
                    {
                        skyward.controls.setValue(element, crqeRecordValue, true);
                    }
                }
            }
        };

        function groupHeaders(crqe)
        {
            const allCRQEs = crqe.find(".childrecordquickentry");
            const headers = crqe.find(":header");

            let scopedHeaders = headers.filter(function ()
            {
                // Check if this header is a descendant of any element in allCRQEs
                return allCRQEs.filter(function ()
                {
                    return $(this).has(this).length > 0;
                }).length === 0;
            });

            const crqeDepth = crqe.parents(".childrecordquickentry").length;
            const workflowOffset = crqe.parents(".workflowPopup").length > 0 ? 1 : 0;
            const baseLineHeaderNumber = 2;
            const depth = crqeDepth + workflowOffset;

            const expectedHeading = "H" + Math.min((Number(depth) + baseLineHeaderNumber), 6); // stop at h6
            scopedHeaders.each(function ()
            {
                const header = $(this);
                // If the header type was specifically specified, respect it.
                if (!header.is("H2"))
                {
                    return;
                }

                if (!header.is(expectedHeading))
                {
                    header.replaceTagNames(expectedHeading);
                }
            });
        }

        function setupButtonToBeResponsiveOnMobile(button)
        {
            skyward.window.registerLayoutResizeCallback(function ()
            {
                resizeResponsiveLegendHeader(button);
            });

            resizeResponsiveLegendHeader(button);
        }

        function resizeResponsiveLegendHeader(buttoncell)
        {
            const container = buttoncell.closest(".childrecordquickentryrow");
            const legendHeader = container.find(".legendHeader");
            if (!legendHeader.length || !buttoncell.length || !legendHeader.is(":visible") || !buttoncell.is(":visible"))
            {
                return;
            }

            const buttonText = buttoncell.find(".buttonText");
            buttonText.show();

            const legendHeaderPosition = legendHeader.position();

            setLegendHeaderMaxWidth();

            if (!isHeaderOverflowing())
            {
                return;
            }

            buttonText.hide();

            setLegendHeaderMaxWidth();

            function isHeaderOverflowing()
            {
                return legendHeader[0].clientWidth < legendHeader[0].scrollWidth;
            }

            function setLegendHeaderMaxWidth()
            {
                const buffer = 15;
                const buttoncellPosition = buttoncell.position();
                legendHeader.css({ maxWidth: `${buttoncellPosition.left - (legendHeaderPosition.left + buffer)}px` });
            }

        }

        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
